<div class="container" *ngIf="workOrder$ | async as workOrder">
  <app-workorder-badge class="badge" [workOrder$]="workOrder$">
  </app-workorder-badge>
  <a class="data" [routerLink]="['./detail/', workOrder.id]">
    <div class="date">
      {{ workOrder.expectedDate | localizedDate : "dd MMMM, yyyy" }}
    </div>

    <div class="externalId">{{ workOrder.externalId }}</div>
    <div class="clientName">{{ workOrder.clientName }}</div>
    <div class="description">{{ workOrder.description }}</div>
    <div class="actions-spacer"></div>
  </a>
  <app-workorder-card-actions class="actions" [workOrder$]="workOrder$">
  </app-workorder-card-actions>
</div>
